export enum LayerImportState {
  SUCCESS,
  IN_PROGRESS,
  FAILED,
  REVERTED,
}

export const LayerImportStateMap = new Map<LayerImportState, string>([
  [LayerImportState.SUCCESS, "Success"],
  [LayerImportState.IN_PROGRESS, "In Progress"],
  [LayerImportState.FAILED, "Failed"],
  [LayerImportState.REVERTED, "Reverted"],
]);
